import Repository from "@/services/Repository";

export default {
  getAttribute(id) {
    return Repository.get(`/latest/dogma/attributes/${id}`);
  }
};
